import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { type ReactNode } from 'react'
import theme from '../../../theme'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CustomTooltip from '../../../components/CustomTooltip'

interface rowData {
  id: number
  step: string
  upload: ReactNode
  status: ReactNode
  details: ReactNode
  isDisabled?: boolean
  disabledText?: string
  tooltipText?: ReactNode
}

interface UploadCsvTableProps {
  rows: rowData[]
}

export const UploadCsvTable: React.FC<UploadCsvTableProps> = ({ rows }): JSX.Element => {
  return (
    <TableContainer sx={{ px: theme.spacing(6) }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ textAlign: 'flex-start', fontWeight: 'bold', width: theme.spacing(50) }}> Upload </TableCell>
            <TableCell sx={{ textAlign: 'center', fontWeight: 'bold', width: theme.spacing(30) }}> Upload CSV </TableCell>
            <TableCell sx={{ textAlign: 'center', fontWeight: 'bold', width: theme.spacing(20) }}> Status </TableCell>
            <TableCell sx={{ textAlign: 'flex-start', fontWeight: 'bold' }}> Details </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row: rowData) => (
            <TableRow
              sx={{
                height: theme.spacing(30),
                opacity: row.isDisabled ? 0.5 : 1,
                pointerEvents: row.isDisabled ? 'none' : 'auto'
              }}
              key={row.id}
            >
              <TableCell sx={{ textAlign: 'center', borderBottom: 'none', padding: 0 }}>
                <CustomTooltip title={row.tooltipText ?? ''} placement="right">
                  <Box sx={{ width: '100%', height: '100%' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: theme.spacing(1),
                        width: '100%',
                        height: '100%',
                        flexGrow: 1,
                        padding: theme.spacing(2)
                      }}
                    >
                      {row.step} <InfoOutlinedIcon fontSize='small' />
                    </Box>
                  </Box>
                </CustomTooltip>
              </TableCell>
              <TableCell sx={{ borderBottom: 'none' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {row.upload}
                </Box>
              </TableCell>
              <TableCell sx={{ textAlign: 'center', borderBottom: 'none' }}>{row.status}</TableCell>
              <TableCell sx={{ textAlign: 'flex-start', borderBottom: 'none' }}>{(row.isDisabled && row.disabledText) ? row.disabledText : row.details}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
